export default "__VITE_ASSET__CZRSQAbj__"